"use client";

import Image from "next/image";
import dynamic from "next/dynamic";
import Info from "@/assets/icon/info.svg?url";
import ManualGroup from "../Input/ManualGroup";

const Spinner = dynamic(() => import("@/components/common/Spinner"), {
  ssr: false,
});

const FindByManual = ({
  t,
  control,
  isDisabled,
  isFetching,
  optionsList,
  handleSubmit,
  findManually,
  hasEngineOpts,
  fetchDetailByManual,
  handleDropdownSelection,
}) => {
  return (
    <form noValidate onSubmit={handleSubmit(fetchDetailByManual)}>
      <div className="selectValueBox">
        <div
          className={`findByRegistrationBox carModel ${
            hasEngineOpts ? "" : "three-value"
          }`}
        >
          <div className="vrm-container relative">
            {isFetching && (
              <div className="flex justify-center absolute w-full h-full top-0 z-[50] blur-backdrop">
                <Spinner />
              </div>
            )}
            <div className="selectBox">
              <ManualGroup
                t={t}
                control={control}
                optionsList={optionsList}
                hasEngineOpts={hasEngineOpts}
                finalSelection={findManually}
                handleChange={handleDropdownSelection}
              />
            </div>

            <button
              type="submit"
              disabled={isDisabled}
              className="green-btn xl:ml-3 ml-0"
            >
              {t("button.find_parts")}
            </button>
          </div>
          <div className="flex-center mt-2 xs:mt-[14px]">
            <Image
              src={Info}
              alt="info"
              width={24}
              height={24}
              unoptimized
              className="me-1 xs:max-w-[24px] max-w-[15px] xs:top-0 -top-[1px] relative"
            />
            <p className="text-minor-text-1-mb xs:text-body-text-3-m lg:text-body-text-2-m text-primary-black">
              {t("button.select_vehicle")}
            </p>
          </div>
        </div>
      </div>
    </form>
  );
};

export default FindByManual;
